<template>
    <footer class="container-fluid bg-secondary py-1 align-self-end">
        <a href="./aviso-privacidad" class="link-light px-5">Aviso de Privacidad</a>
        <span class="text-light m-0 px-3">Web-Sait SA de CV &copy; 2021</span>
    </footer>
</template>

<script>

export default {
  name: 'Footer',
  
  /*props: {
    
  },
  setup(props){
    
  }*/
}
</script>

<style scoped>
</style>